<template>
  <div
    :style="'background-image: url('+bg+');background-size: cover;width:100%;height: 100%;position:absolute;'"
  ></div>
</template>
<script>
export default {
  data() {
    return {
      bg: `${this.$baseUrl}image/theme/default/admin_bg.jpg`,
    };
  },
};
</script>
<style>
.hidden-header {
  display: none;
}
</style>
